/**
 * Pages statiques du site : titre, description et poids dans le sitemap.
 * Le titre et la description sont lus par useSeo() (balises <title>, meta, Open Graph) et par prerender.js (sitemap),
 * pour qu'une page ne puisse pas être référencée avec un texte différent de celui qu'elle affiche.
 *
 * Titres : viser 60 caractères maximum. Descriptions : 150 à 160 caractères.
 */
module.exports = [
    {
        path: '/',
        name: 'Accueil',
        title: 'Logiciel de devis et factures électroniques | Citron Digital',
        description: 'Logiciel de facturation en ligne pour TPE et indépendants : devis, acomptes, avoirs, factures Factur-X, CRM clients, achats, stock et export comptable FEC.',
        lastmod: '2026-11-04',
        priority: '1.0',
        changefreq: 'weekly'
    },
    {
        path: '/gestionnaire-citron',
        name: 'Logiciel de gestion TPE',
        title: 'Logiciel de gestion TPE : devis, factures, achats et FEC',
        description: 'Logiciel de gestion en ligne, entre CRM et ERP léger : prospects, devis, acomptes, factures Factur-X, achats, stock, export FEC et statistiques, en équipe.',
        lastmod: '2026-11-04',
        priority: '0.9',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/devis-factures',
        name: 'Devis et factures',
        title: 'Devis et factures : acompte, facture finale, avoir en ligne',
        description: 'Créez devis, factures d\'acompte, factures finales (ou définitives) et avoirs en PDF, avec signature par QR code, TVA et numérotation continue.',
        lastmod: '2026-11-04',
        priority: '0.8',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/facturation-electronique',
        name: 'Facturation électronique',
        title: 'Facturation électronique : Factur-X et plateforme agréée',
        description: 'Générez des factures Factur-X et transmettez-les à une plateforme agréée, avec le suivi de chaque facture, acompte et avoir. Réforme 2026-2027.',
        lastmod: '2026-11-04',
        priority: '0.9',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/comptabilite',
        name: 'Encaissements et TVA',
        title: 'Logiciel de suivi des encaissements, de la TVA et des impayés',
        description: 'Encaissements par carte, virement ou espèces, situation financière de chaque dossier, TVA collectée et non encaissée, impayés et accès pour votre comptable.',
        lastmod: '2026-11-04',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/achats-logistique',
        name: 'Achats et logistique',
        title: 'Achats, fournisseurs et stock : un ERP léger pour TPE',
        description: 'Factures fournisseurs, paiements, réception, stock et catalogue d\'articles : ventilez chaque achat sur vos dossiers et suivez votre marge, sans ERP lourd.',
        lastmod: '2026-11-04',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/export-comptable',
        name: 'Export comptable (FEC)',
        title: 'Export comptable FEC et Excel pour votre expert-comptable',
        description: 'Exportez un FEC (18 colonnes) et un classeur Excel depuis vos factures, achats et encaissements : journaux, lettrage, TVA et contrôles.',
        lastmod: '2026-11-04',
        priority: '0.8',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/statistiques',
        name: 'Statistiques',
        title: 'Statistiques de facturation : CA, devis, clients, retards',
        description: 'Suivez chiffre d\'affaires facturé et encaissé, taux de signature des devis, clients actifs et factures en retard, par mois, trimestre ou année.',
        lastmod: '2026-11-04',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/gestionnaire-citron/clients-prospects',
        name: 'Clients et prospects',
        title: 'CRM pour TPE : clients, prospects et suivi jusqu\'au devis',
        description: 'Un CRM simple : centralisez vos prospects et clients, gardez l\'historique des échanges et transformez un contact en devis puis en facture, sans ressaisie.',
        lastmod: '2026-11-04',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/blog',
        name: 'Blog',
        title: 'Guides facturation : acompte, avoir, FEC, Factur-X, devis',
        description: 'Guides pour TPE et indépendants : facture d\'acompte et facture finale, facture d\'avoir, FEC, Factur-X, devis, facturation électronique, ERP et CRM.',
        lastmod: '2026-11-04',
        priority: '0.8',
        changefreq: 'weekly'
    },
    {
        path: '/site-web',
        name: 'Création de site web',
        title: 'Création de site vitrine à Toulouse, pensé pour le SEO',
        description: 'Site vitrine sur mesure à Toulouse : design, référencement naturel, hébergement et maintenance. Un interlocuteur unique, de la conception à la mise en ligne.',
        lastmod: '2026-10-19',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/logiciel',
        name: 'Logiciel sur mesure',
        title: 'Développement de logiciel et d\'application web sur mesure',
        description: 'Création, maintenance et évolution de logiciels et d\'applications web SaaS sur mesure : correction de bugs, migration, API, sécurité. Devis personnalisé.',
        lastmod: '2026-10-19',
        priority: '0.7',
        changefreq: 'monthly'
    },
    {
        path: '/portfolio',
        name: 'À propos',
        title: 'À propos de Franck Besson, fondateur de Citron Digital',
        description: 'Parcours de Franck Besson : développeur full stack, micro-entrepreneur depuis 2020 et créateur d\'un logiciel de devis et de factures. Expériences et formations.',
        lastmod: '2026-11-04',
        priority: '0.5',
        changefreq: 'yearly'
    },
    {
        path: '/contact',
        name: 'Contact',
        title: 'Contact et demande de devis | Citron Digital',
        description: 'Un projet de site, de logiciel ou une question sur le logiciel de facturation ? Écrivez à Franck Besson par e-mail, téléphone ou LinkedIn.',
        lastmod: '2026-11-04',
        priority: '0.6',
        changefreq: 'yearly'
    },
    {
        // Page obligatoire mais sans intérêt pour les moteurs : lisible, non indexée, absente du sitemap
        path: '/mentions-legales',
        name: 'Mentions légales',
        title: 'Mentions légales | Citron Digital',
        description: 'Éditeur, hébergeur et informations légales du site citrondigital.fr.',
        noindex: true,
        sitemap: false
    }
];
